import ManualBook from './components/booking/ManualBook';
import AvisBook from './components/booking/AvisBook';
import Rebook from './components/booking/Rebook';
import Vue from 'vue';

Vue.component('manual-book', ManualBook);
Vue.component('avis-book', AvisBook);
Vue.component('rebook', Rebook);

$(document).ready(function () {
    if (document.getElementById('manual_booking_hidden')) {
        /* create customer */
        var modal = document.getElementById("myManualBookingModal");
        var btn = document.getElementById("popupCreateManualBooking");
        var span = document.getElementsByClassName("close");
        btn.onclick = function () {
            modal.style.display = "block";
        };

        [].forEach.call(span,function (item) {
            item.onclick = function(){
                modal.style.display = "none";
                document.getElementById("myRebookModal").style.display = "none";
            };
        });

        window.onclick = function (event) {
            if (event.target == modal) {
                modal.style.display = "none";
            }

            if (event.target == document.getElementById("myRebookModal")) {
                document.getElementById("myRebookModal").style.display = "none";
            }
        };

        document.getElementById("popupCreateRebook").onclick = function (ev) {
            document.getElementById("myRebookModal").style.display = "block";
        };


        $('#manual_booking_create_btn').on('click', function () {
            if (confirm(trans('page.management.booking.add_booking_q'))) {
                let skus = [];
                let places = [];
                let quantities = [];

                $('#createManualModalItems input[name^=product_sku]').each(function () {
                    skus.push(this.value.split(" - ")[0]);
                });
                $('#createManualModalItems input[name^=storage_places]').each(function () {
                    places.push(this.value.split(" - ")[0]);
                });
                $('#createManualModalItems input[name^=quantity]').each(function () {
                    quantities.push(this.value);
                });


                $.ajax({
                    url: '/manage/storage/booking/manual/create',
                    type: "post",
                    dataType: "json",
                    data: {
                        skus: skus,
                        quantities: quantities,
                        places: places,
                    },
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function (data) {
                        alert(trans('page.management.booking.booking_was_created'));
                        location.reload();

                    },
                    error: function (data) {
                        let json = data.responseJSON;
                        let errorMsg = trans('page.management.avis.avis_error');
                        let errors = Object.values(json.errors)

                        errors.forEach(function (value) {
                            if( value.isArray === true ){
                                value.forEach(function (msg) {
                                    errorMsg = errorMsg + '\n' + msg;
                                })
                            } else {
                                errorMsg = errorMsg + '\n' + value;
                            }
                        });

                        alert(errorMsg);
                    }
                });
            } else {
            }
        });
    }
});